/**
 * Subtle storefront interactions — gallery helpers live on PDP.
 * Respects prefers-reduced-motion only when the OS/browser actually prefers it.
 */
(function () {
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduceMotion = function () {
    return !!reduceMq.matches;
  };

  /* Hero slideshow — crossfade, pause on hover, static if reduced motion */
  var hero = document.querySelector('[data-adc-hero-slideshow]');
  if (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-adc-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-adc-hero-dot]'));
    var controls = hero.querySelector('[data-adc-hero-controls]');
    var intervalMs = parseInt(hero.getAttribute('data-interval') || '5000', 10) || 5000;
    var index = Math.max(
      0,
      slides.findIndex(function (s) {
        return s.classList.contains('is-active');
      })
    );
    if (index < 0) index = 0;
    var timer = null;
    var hoverPaused = false;
    var focusPaused = false;
    var hoverBound = false;

    var exitTimer = null;
    var goTo = function (next) {
      if (!slides.length) return;
      var n = ((next % slides.length) + slides.length) % slides.length;
      if (n === index) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === n);
          slide.classList.remove('is-exiting');
        });
      } else {
        var prev = index;
        // Incoming fully opaque underneath; outgoing fades out on top (dissolve).
        slides.forEach(function (slide, i) {
          slide.classList.remove('is-exiting');
          if (i === n) {
            slide.classList.add('is-active');
          } else if (i === prev) {
            slide.classList.add('is-exiting');
            slide.classList.remove('is-active');
          } else {
            slide.classList.remove('is-active');
          }
        });
        if (exitTimer) window.clearTimeout(exitTimer);
        exitTimer = window.setTimeout(function () {
          if (slides[prev]) slides[prev].classList.remove('is-exiting');
          exitTimer = null;
        }, 850);
      }
      dots.forEach(function (dot, i) {
        var on = i === n;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      index = n;
    };

    var stop = function () {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    var start = function () {
      stop();
      if (reduceMotion() || slides.length < 2 || hoverPaused || focusPaused) return;
      timer = window.setInterval(function () {
        if (reduceMotion() || hoverPaused || focusPaused) return;
        goTo(index + 1);
      }, intervalMs);
    };

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index') || '0', 10) || 0;
        goTo(i);
        // Blur so focus-pause (bound on controls) cannot leave autoplay stuck
        // after a dot tap — common on desktop mouse clicks.
        if (typeof dot.blur === 'function') dot.blur();
        focusPaused = false;
        start();
      });
    });

    // True mouse/trackpad only. Touch + pointerenter sticks hoverPaused
    // forever (pointerleave rarely fires), and the mobile full-bleed stage
    // (~72vh) is almost always under the first finger scroll/tap.
    var canHoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
    var canHover = function () {
      return !!canHoverMq.matches;
    };

    var bindHoverPause = function () {
      if (hoverBound || !canHover()) return;
      hoverBound = true;
      // Pause only over the product stage — not the whole hero — so resting
      // cursor / CTA hover cannot permanently stall autoplay.
      var hoverTarget = hero.querySelector('.adc-hero__media') || hero;
      hoverTarget.addEventListener('pointerenter', function () {
        if (!canHover()) return;
        hoverPaused = true;
        stop();
      });
      hoverTarget.addEventListener('pointerleave', function () {
        hoverPaused = false;
        start();
      });
    };

    // Pause only when focus is inside the dot controls — not when tabbing CTAs
    // (CTA focusin previously left autoplay stuck paused).
    if (controls) {
      controls.addEventListener('focusin', function () {
        focusPaused = true;
        stop();
      });
      controls.addEventListener('focusout', function (e) {
        if (controls.contains(e.relatedTarget)) return;
        focusPaused = false;
        start();
      });
    }

    // Light swipe on the stage (touch / pen). Does not cancel autoplay.
    var stage = hero.querySelector('.adc-hero__stage');
    if (stage && slides.length > 1) {
      var swipeX = null;
      var swipeY = null;
      stage.addEventListener(
        'pointerdown',
        function (e) {
          if (e.pointerType === 'mouse') return;
          swipeX = e.clientX;
          swipeY = e.clientY;
        },
        { passive: true }
      );
      stage.addEventListener(
        'pointerup',
        function (e) {
          if (swipeX == null || e.pointerType === 'mouse') return;
          var dx = e.clientX - swipeX;
          var dy = e.clientY - swipeY;
          swipeX = null;
          swipeY = null;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
          goTo(index + (dx < 0 ? 1 : -1));
          start();
        },
        { passive: true }
      );
      stage.addEventListener(
        'pointercancel',
        function () {
          swipeX = null;
          swipeY = null;
        },
        { passive: true }
      );
    }

    goTo(index);

    // Start autoplay first; bind hover pause after a beat so a resting cursor
    // over the hero (common on load) cannot block the first interval forever.
    // Skip hover-bind entirely on coarse touch — see canHoverMq above.
    window.setTimeout(function () {
      start();
      window.setTimeout(bindHoverPause, 250);
    }, 120);

    if (typeof canHoverMq.addEventListener === 'function') {
      canHoverMq.addEventListener('change', function () {
        if (!canHover()) {
          hoverPaused = false;
          start();
        } else {
          bindHoverPause();
        }
      });
    }

    if (typeof reduceMq.addEventListener === 'function') {
      reduceMq.addEventListener('change', function () {
        if (reduceMotion()) stop();
        else start();
      });
    } else if (typeof reduceMq.addListener === 'function') {
      reduceMq.addListener(function () {
        if (reduceMotion()) stop();
        else start();
      });
    }
  }

  /* Sticky chrome: shadow + mobile scroll-direction hide/show */
  var chrome = document.querySelector('[data-adc-chrome]');
  var header = document.querySelector('.adc-header');
  var searchToggle = document.querySelector('[data-adc-search-toggle]');
  var searchPanel = document.querySelector('[data-adc-search-panel]');
  var searchInput = document.querySelector('[data-adc-search-input]');
  var mobileChromeMq = window.matchMedia('(max-width: 860px)');
  var isMobileChrome = function () {
    return !!mobileChromeMq.matches;
  };
  var searchOpen = false;

  var setSearchOpen = function (open) {
    searchOpen = !!open;
    if (header) header.classList.toggle('is-search-open', searchOpen);
    if (searchToggle) {
      searchToggle.setAttribute('aria-expanded', searchOpen ? 'true' : 'false');
      searchToggle.setAttribute('aria-label', searchOpen ? 'Close search' : 'Open search');
    }
    if (searchOpen) {
      if (chrome) chrome.classList.remove('is-header-hidden');
      if (searchInput && typeof searchInput.focus === 'function') {
        window.setTimeout(function () {
          searchInput.focus();
        }, 10);
      }
    }
  };

  if (searchToggle && searchPanel && header) {
    searchToggle.addEventListener('click', function () {
      if (!isMobileChrome()) return;
      setSearchOpen(!searchOpen);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOpen) {
        setSearchOpen(false);
        searchToggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!searchOpen || !isMobileChrome()) return;
      if (header.contains(e.target)) return;
      setSearchOpen(false);
    });

    if (typeof mobileChromeMq.addEventListener === 'function') {
      mobileChromeMq.addEventListener('change', function () {
        if (!isMobileChrome()) setSearchOpen(false);
      });
    } else if (typeof mobileChromeMq.addListener === 'function') {
      mobileChromeMq.addListener(function () {
        if (!isMobileChrome()) setSearchOpen(false);
      });
    }
  }

  if (chrome) {
    var lastY = window.scrollY || 0;
    var hideOffset = 72;
    var onScroll = function () {
      var y = window.scrollY || 0;
      chrome.classList.toggle('is-scrolled', y > 8);

      if (!isMobileChrome() || searchOpen) {
        chrome.classList.remove('is-header-hidden');
        lastY = y;
        return;
      }

      // Classic: hide while scrolling down, show while scrolling up.
      // Small delta avoids micro-jitter flicker on mobile rubber-banding.
      var goingDown = y > lastY + 3;
      var goingUp = y < lastY - 3;
      if (goingDown && y > hideOffset) {
        chrome.classList.add('is-header-hidden');
      } else if (goingUp) {
        chrome.classList.remove('is-header-hidden');
      }
      if (y <= 8) chrome.classList.remove('is-header-hidden');
      lastY = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile sticky add-to-cart mirrors primary CTA */
  var sticky = document.querySelector('[data-adc-sticky-atc]');
  var form = document.getElementById('AdcProductForm');
  if (sticky && form) {
    var trigger = form.querySelector('[name="add"], button[type="submit"]');
    var stickyBtn = sticky.querySelector('[data-adc-sticky-submit]');
    var setStickyVisible = function (visible) {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };
    if (trigger && stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (trigger.disabled) return;
        trigger.click();
      });
    }
    if ('IntersectionObserver' in window && trigger) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setStickyVisible(!entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0 }
      );
      io.observe(trigger);
    } else {
      setStickyVisible(true);
    }
  }

  /* Add-to-cart press feedback on primary button */
  if (form && !reduceMotion()) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[name="add"]');
      if (!btn || btn.disabled) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    });
  }
})();
